var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('Header'),_c('HeaderInfo'),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pay__info__wrap"},[_c('img',{attrs:{"src":"https://bpcard.ru//images/kalr.png","alt":""}}),_c('h4',[_vm._v("Платеж успешно обработан")]),_c('h3',[_vm._v("Деньги зачисляются на счет в течении 20 минут")])])
}]

export { render, staticRenderFns }